import script from "./MeetingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingsView.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingsView.vue?vue&type=style&index=0&id=84743b4c&lang=css"

const __exports__ = script;

export default __exports__